import { Select } from '@kcftech/design-system';
import {
    AssemblyParameterFormInputProps,
    typeGuardAssemblyParameterForm,
} from 'pages/Settings/AssemblyType/parameter_form/types';
import { Controller } from 'react-hook-form';

export const options = [
    { title: 'Unchecked', value: 'false' },
    { title: 'Checked', value: 'true' },
];

export function AssemblyParameterBoolFormContent({
    form: _form,
}: AssemblyParameterFormInputProps) {
    const form = typeGuardAssemblyParameterForm(_form, 'bool');

    const {
        control,
        formState: { errors },
    } = form;

    return (
        <Controller
            control={control}
            name="defaultValue"
            render={({ field: { value, onChange } }) => (
                <Select
                    label="Default Status"
                    error={errors.defaultValue?.message}
                    options={options}
                    value={value ? 'true' : 'false'}
                    onChange={(event) => onChange(event.target.value === 'true')}
                />
            )}
        />
    );
}
